import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";
import {toast} from 'react-toastify'
function DayForm({ dayData, hof, handleEdit,updateHours }) {
 const {clinicId} = useParams()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      day: dayData.day,
      start: dayData.start,
      end: dayData.end,
      note: dayData.note,
      status: dayData.status,
      id:dayData.id,
      clinicId:dayData.clinicId,
    },
  });

  const onSubmit = (data)=>{
    
    const newData = hof.map((item)=>{
        if(item.id === data.id){
             const sta = data.status==='1'?1:0
            return ({...data,status:sta})
        }else{
            return item
        }
    })
    console.log(newData)
     clinicService.updateHours(clinicId,newData)
     .then(res=>{
        console.log(res.data)
        updateHours(res.data)
        toast.success("Hours Updated!",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
     })
     .catch(err=>{
        toast.error("Error While updating Hours",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
     })
    handleEdit()
  }
  return (
    
     
        
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-3 col-md-3">
          
              
       
              
                <select 
                  className="form-select"
                  {...register("day")}
                  >
                    <option value="MONDAY">Monday</option>
                    <option value="TUESDAY">Tuesday</option>
                    <option value="WEDNESDAY">Wednesday</option>
                    <option value="THURSDAY">Thursday</option>
                    <option value="FRIDAY">Friday</option>
                    <option value="SATURDAY">Saturday</option>
                    <option value="SUNDAY">Sunday</option>
                  </select>
             
            </div>
            <div className="col-lg-3 col-md-3 d-flex justify-content-center align-item-center">
              <input 
                type="text"
                className="form-control me-2"
                placeholder="Start"
                {...register("start")}
                />
                
                <input 
                type="text"
                placeholder="End"
                className="form-control"
                {...register("end")}
                />
            </div>
            <div className="col-lg-2 col-md-2">
              <select
                  className="form-select"
                  {...register("status")}
                  >
                    <option value="1">Open</option>
                    <option value="0">Closed</option>
                  </select>
           
            </div>
            <div className="col-lg-2 col-md-2">
              <input 
                type="text"
                className="form-control"
                placeholder="Note"
                {...register("note")}
                />
           
            </div>
          <div className="col-lg-2 col-md-2 d-flex align-items-center">
            <button className="btn btn-sm btn-success me-2" type="submit">Save</button>
            <button className="btn btn-sm btn-secondary" onClick={()=>{handleEdit()}} >Cancel</button>
          </div>
          </form>
       
  );
}

export default DayForm;
